import Vue from "vue";
import Vuetify from "vuetify/lib";
import SharedComponents from "shared-components";

Vue.use(Vuetify);

const opts = {
  iconfont: "mdi",
  ...SharedComponents.vuetifyOpts,
};

export default new Vuetify(opts);
